const CardData = [{
    "Feature": [{
        "id": "1",
        "forgrid": "first",
        "cflag": require("./img/Nepal.gif"),
        "alt": "Nepal",
        "cname": "Nepali",
        "bgimg": require("./img/Nepal.jfif"),
        "cprop": "4,795 properties",
    },
    {
        id: 2,
        forgrid: "second",
        cflag: require("./img/el.png"),
        alt: "Kuala Lumpur",
        cname: "Kuala Lumpur",
        bgimg: "https://cf.bstatic.com/xdata/images/city/540x270/685532.webp?k=27f5778aebf08d8894506a031c18df7180c530a0937ad377c2b3ecaa540fe9f7&o=",
        cprop: "4,795 properties",
    },
    {
        id: 3,
        forgrid: "third",
        cflag: require("./img/Dubai.png"),
        alt: "Dubai",
        cname: "Dubai",
        bgimg: "https://cf.bstatic.com/xdata/images/city/540x270/619923.jpg?k=4fb13225390240a51ee5aa1d76318d03dc0de8a046ddc06e4598f17b287bdcc9&o=",
        cprop: "4,795 properties",
    },
    {
        id: 4,
        forgrid: "fourth",
        cflag: require("./img/el.png"),
        alt: "El nido",
        cname: "El nido",
        bgimg: "https://cf.bstatic.com/xdata/images/city/540x270/685698.jpg?k=b28763e2406750586d0dfe688ef8770ba560b995d45bdf2d98e3ce100fd56e63&o=",
        cprop: "4,795 properties",
    },
    {
        id: 5,
        forgrid: "fifth",
        cflag: require("./img/Singa.png"),
        alt: "Singapour",
        cname: "Singapour",
        bgimg: "https://cf.bstatic.com/xdata/images/city/540x270/619666.jpg?k=504b97635641d489438feb63780d4ae80ce8a2fd08a1fcb6183485738a87e6ad&o=",
        cprop: "4,795 properties",
    }],

    "Explore": [
        {
            img: require("./img/explore/1.webp"),
            name: "Pokhara",
            prop: "600 properties",
        },
        {
            img: require("./img/explore/2.webp"),
            name: "Kathmandu",
            prop: "929 properties",
        },

        {
            img: require("./img/explore/3.webp"),
            name: "Nagarkot",
            prop: "600 properties",
        },

        {
            img: require("./img/explore/4.webp"),
            name: "Sauraha",
            prop: "108 properties",
        },

        {
            img: require("./img/explore/5.webp"),
            name: "Chitwan",
            prop: "23 properties",
        },

        {
            img: require("./img/explore/6.webp"),
            name: "Dhulikhel",
            prop: "48 properties",
        },

        {
            img: require("./img/explore/7.webp"),
            name: "Bhaktapur",
            prop: "108 properties",
        },

        {
            img: require("./img/explore/8.webp"),
            name: "Bandipur",
            prop: "25 properties",
        },

        {
            img: require("./img/explore/9.webp"),
            name: "Rummindei",
            prop: "34 properties",
        },

        {
            img: require("./img/explore/10.webp"),
            name: "Patan",
            prop: "166 properties",
        },

    ],

    "Browse": [
        {
            img: require("./img/property/1.webp"),
            name: "Hotels",
            props: "859,581 hotels",
        },
        {
            img: require("./img/property/2.jpg"),
            name: "Apartments",
            props: "814,616 apartments",
        },
        {
            img: require("./img/property/3.jpg"),
            name: "Resorts",
            props: "17,809 resorts",
        },
        {
            img: require("./img/property/4.jpg"),
            name: "Villas",
            props: "426,626 villas",
        },
        {
            img: require("./img/property/5.jpg"),
            name: "Cabins",
            props: "33,572 cabins",
        },
        {
            img: require("./img/property/6.jpg"),
            name: "Cottages",
            props: "143,194 cottages",
        },
        {
            img: require("./img/property/7.jpg"),
            name: "Glamping",
            props: "11,811 Glamping Sites",
        },
        {
            img: require("./img/property/8.jpg"),
            name: "Serviced Apartments",
            props: "33,495 serviced apartments",
        },
        {
            img: require("./img/property/9.jpg"),
            name: "Vacation Homes",
            props: "426,626 vacation homes",
        },
        {
            img: require("./img/property/10.jpg"),
            name: "Guest houses",
            props: "101,959 guest houses",
        },
        {
            img: require("./img/property/11.jpg"),
            name: "Hostels",
            props: "16,396 hostels",
        },
        {
            img: require("./img/property/12.jpg"),
            name: "Motels",
            props: "13,054 motels",
        },
        {
            img: require("./img/property/13.jpg"),
            name: "",
            props: "",
        },
        {
            img: require("./img/property/14.jpg"),
            name: "B&Bs",
            props: "197,433 B&Bs",
        },
        {
            img: require("./img/property/15.jpg"),
            name: "Ryokans",
            props: "2,030 ryokans",
        },
        {
            img: require("./img/property/16.jpg"),
            name: "Riads",
            props: "1,197 riads",
        },
        {
            img: require("./img/property/17.jpg"),
            name: "Resort Villages",
            props: "5,589 resort villages",
        },
        {
            img: require("./img/property/18.jpg"),
            name: "Homestays",
            props: "134,633 homestays",
        },
        {
            img: require("./img/property/19.jpg"),
            name: "Campgrounds",
            props: "8,856 campgrounds",
        },
        {
            img: require("./img/property/20.jpg"),
            name: "Country Houses",
            props: "11,942 country houses",
        },
        {
            img: require("./img/property/21.jpg"),
            name: "Farm Stays",
            props: "10,804 farm stays",
        },
        {
            img: require("./img/property/22.jpg"),
            name: "Boats",
            props: "1,371 boats",
        },
        {
            img: require("./img/property/23.jpg"),
            name: "Luxury Tents",
            props: "3,610 luxury tents",
        },
        {
            img: require("./img/property/24.jpg"),
            name: "Self-catering Accommodations",
            props: "719,283 Self-catering Properties",
        },
        {
            img: require("./img/property/11.jpg"),
            name: "Tiny houses",
            props: "470 tiny houses",
        },

    ],

    "Remove": [
        {

            img: require("./img/subscribe.png"),
            head: "Subscribe to see Secret Deals...",
            subhead: "Prices drop the second you sign up!",
            inbutton: "Sign Up !",

        },
        {

            img: require("./img/globe.png"),
            head: "Get instant discounts",
            subhead: "Just sign into your Booking.com account and look for the blue Genius logo to save",
            inbutton: "Sign In",

        },
    ],
    "Trip": [
        {
            id: "1",
            position: "first",
            img: require("./img/trip/1.webp"),
            head: "7 European landmarks you can’t miss",
            description: "Check these must-see spots off your list."
        },
        {
            id: "2",
            position: "second",
            img: require("./img/trip/t2.webp"),
            head: "The best of the earth's natural beauty",
            description: "Marvel at the spectacle of mother nature at these fascinating locations.",
        },
        {
            id: "3",
            position: "third",
            img: require("./img/trip/t3.webp"),
            head: "The most beautiful destinations for spring",
            description: "The best places to enjoy spring around the world.",
        },
        {
            id: "4",
            position: "fourth",
            img: require("./img/trip/t4.webp"),
            head: "New York City’s 6 most fashionable hotels",
            description: "Celebrate Fashion Week in style at one of these trendsetting spots.",
        },
        {
            id: "5",
            position: "fifth",
            img: require("./img/trip/t5.webp"),
            head: "The top 5 cities for vegan travelers",
            description: "Vegan-friendly eateries abound in these travel destinations…",
        },

    ],

    "Guest": [
        {
            img: require("./img/Guests/1.jpg"),
            name: "The Patio Barcelona",
            cname: "Barcelona",
            price: "78,295",
            rating: "9.2",
            expression: "Wonderful",
            review: "56 reviews",
        },
        {
            img: require("./img/Guests/2.jpg"),
            name: "LivinParis - Luxury 3 Bedrooms Grands-Boulevards I",
            cname: "Paris",
            price: "37,660",
            rating: "  7.5 ",
            expression: "Good",
            review: "110 reviews",
        },
        {
            img: require("./img/Guests/3.jpg"),
            name: "Elegant & Stylish Apartment city center",
            cname: "Budapest",
            price: "24,793",
            rating: "9.3",
            expression: " Wonderful ",
            review: "38 reviews ",
        },
        {
            img: require("./img/Guests/4.jpg"),
            name: "Leman Locke",
            cname: "London",
            price: "26,809",
            rating: "8.9",
            expression: " Excellent",
            review: "  1,642 reviews ",
        },
        {
            img: require("./img/Guests/5.jpg"),
            name: "Flora Chiado Apartments",
            cname: "Lisbon",
            price: "42,671",
            rating: "9.7",
            expression: "Exceptional",
            review: "205 reviews ",
        },
        {
            img: require("./img/Guests/6.jpg"),
            name: "last",

        }
    ],
    "Connect": [
        {
            img: require("./img/connect/c1.jpg"),
            name: " France",
            props: "Travel community",
            props2: "393,688 travelers",
        },
        {
            img: require("./img/connect/1.jpg"),
            name: " Nepal",
            props: "Travel community",
            props2: "12,887 travelers",
        },
        {
            img: require("./img/connect/2.jpg"),
            name: "Travel Talk",
            props: "General discussion",
            props2: "559,436 travelers",
        },
        {
            img: require("./img/connect/3.png"),
            name: "More communities",
            props: "View all",
            props2: "9,894,940 travelers",
        },
    ],
    "Destinationtabs": [{
        "Region": [
            {
                name: " Bali",
                subname: "12,683 properties",

            },
            {
                name: "Santorini",
                subname: "1,762 properties",

            },
            {
                name: "Uttar Pradesh",
                subname: "4, 374 properties",

            },
            {
                name: "Bora Bora",
                subname: "59 properties",

            },
            {
                name: "Hawaii",
                subname: "5, 516 properties",

            },
            {
                name: "England",
                subname: "74, 087 properties",

            },
            {
                name: "Phuket Province",
                subname: "5, 499 properties",

            },
            {
                name: "Lake District",
                subname: "2, 413 properties",

            },
            {
                name: "Guernsey",
                subname: "61 properties",

            },
            {
                name: "Ras Al Khaimah",
                subname: "114 properties",

            },
            {
                name: "Texel",
                subname: "411 properties",

            },
            {
                name: "Jersey",
                subname: "89 properties",

            },
            {
                name: "Isle of Wight",
                subname: "936 properties",

            },
            {
                name: "Cornwall",
                subname: "5, 286 properties",

            },
            {
                name: "Tenerife",
                subname: "9, 623 properties",

            },
            {
                name: "Zanzibar",
                subname: "834 properties",

            },
            {
                name: "Ibiza",
                subname: "1, 642 properties",

            },
            {
                name: "Mykonos",
                subname: "1, 455 properties",

            },
            {
                name: "Bihar",
                subname: "761 properties",

            },

        ],
        "Interest": [
            {
                name: "Al Maha Wildlife Reserve",
                subname: "1 property",
            },
            {
                name: "Burj Al Arab Tower",
                subname: "4,286 properties",
            },
            {
                name: "Times Square",
                subname: "1, 381 properties",
            },
            {
                name: "Comal River Tubing",
                subname: "327 properties",
            },
            {
                name: "River Walk",
                subname: "670 properties",
            },
            {
                name: "State Park",
                subname: "21 properties",
            },
            {
                name: "Ocean City Boardwalk",
                subname: "766 properties",
            },
            {
                name: "Heathrow Terminal 2",
                subname: "",
            },
            {
                name: "Disneyland Paris",
                subname: "7, 555 properties",
            },
            {
                name: "The Shard",
                subname: "14, 502 properties",
            },
            {
                name: "Disneyland",
                subname: "247 properties",
            },
            {
                name: "Eiffel Tower",
                subname: "7, 555 properties",
            },
            {
                name: "Kalahari Waterpark",
                subname: "43 properties",
            },
            {
                name: "Portmeirion",
                subname: "9 properties",
            },
            {
                name: "Wembley Stadium",
                subname: "14, 502 properties",
            },
            {
                name: "O2 Arena",
                subname: "14, 502 properties",
            },
            {
                name: "Guadalupe River Tubing",
                subname: "327 properties",
            },
            {
                name: "Universal Studios Orlando",
                subname: "3, 684 properties",
            },
            {
                name: "Heathrow Terminal 5",
                subname: "62 properties",
            },
            {
                name: "Niagara Falls State Park ",
                subname: "75 properties",
            },

        ]
    }],
    "Footerlogo":[
        {
            "img": require("./img/footer/1.png"),
    },
    {
        img:require("./img/footer/2.png")
    },
    {
        img:require("./img/footer/3.png")
    },
    {
        img:require("./img/footer/4.png")
    },
    {
        img:require("./img/footer/5.png")
    },
    {
        img:require("./img/footer/6.png")
    },
]
}
]
export default CardData;

